<template>
  <div class="editorial">
    <div class="editorial_nav">
      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2" style="cursor: pointer;" @click="tiao">
          首页 <span class="span1">></span><span style="color: var(--xt);">{{titlename}}</span>
        </div>
      </div>
      <div class="editorial_left">
        <div class="express_nav2">
          <div class="express_rtitle">
            <div class="waike">{{titlename}}</div>
            <div class="waixian"></div>
          </div>
          <div class="express_nav2r">
            <div class="express_list2" v-for="(item,index) in xia" :key="index" @click="down(item.channelId,item.contentId,30,item.title)">
              <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop3(1,index)" @mouseout="addtop3(2,index)"></div>
              <div class="express_wen" @mouseover="addtop3(1,index)" @mouseout="addtop3(2,index)" style="overflow: hidden;width: 89%;">
                <div class="wen1" :class="item.zt?'add1':''" style="float: left;"><span class="span3" :class="item.zt?'add1':''">{{item.title}}</span>
                  <span style="max-width: 30%; float: right;text-align: right;" v-if="item.hits">({{item.hits}})</span>
                  <span style="max-width: 30%; float: right;text-align: right;" v-if="item.hitCount">({{item.hitCount}})</span>
                  <span style="max-width: 30%; float: right;text-align: right;" v-if="!item.hitCount && !item.hits">(0)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="curr"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      tu: false,
      titlename: '',
      curr: 1,//当前页数
      total: 0,//总条数
      limit: 10,
      list3: [],//详情数据
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      xia: [],//下载排行  浏览排行
      liu: [],//浏览排行
      list: [
        {
          id: 1,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 2,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 3,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 4,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 5,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 6,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 7,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 8,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 9,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        }
      ],//专家列表
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗123',
          time: '2020-03-25'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究中国腹腔镜减重代谢外科20年研究',
          time: '2020-03-25'
        },
        {
          id: 3,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 4,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 5,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 6,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 7,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 8,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
        {
          id: 9,
          txt: '多西他赛对进展期胃癌术后化疗多西他赛对进展期胃癌术后化疗',
          time: '2020-03-25'
        },
      ],//相关推荐
    }
  },

  methods:{
      tiao(){
        this.$router.push({path:'/home'});
      },
      //下载排行
      GetJournalArticleList(num){
        var that = this;
        that.$httphelper.GetJournalArticleList({
          "journalId": that.$_JournalId,
          "queryType": num,
          "curr": that.curr,
          "limit": that.limit
        }).then(res => {
          if(res.code==200){
            that.xia = res.data || '';
            that.total = res.totalcount;
            that.$loading.hideLoading();
          }else{
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },

      GetHomePageBlockInfo(jChannelID,dataSourceType){
        var that = this;
        that.$httphelper.GetHomePageBlockInfo({
          "journalId": 201607080003,
          "pChannelId": 0,
          "channelId": jChannelID,
          "jChannelID": 0,
          "dataSourceType": dataSourceType,
          "dataShowType": 1,
          "curr": that.curr,
          "limit": that.limit,
        }).then(res => {
          if(res.code==200){
            that.xia = res.data || '';
            that.total = res.totalcount;
            that.$loading.hideLoading();
          }else{
            that.show = true;
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      // jump(year,issue,contentId){

      //   this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:contentId}});
      // },

      down(channelId,contentId,num,i){
      var that = this;
      console.log(i)
      if(this.titlename=='精品会议'){
          this.$router.push({path:'/xinwen',query:{titlename:i}});

      }else{

      that.$httphelper.GetContentInfo({
       "journalId": 201607080003,
        "year": 0,
        "issue": 0,
        "channelId": channelId,
        "contentId": contentId,
        "dataSourceType": 1,
        "dataShowType": 1
      }).then(res => {
        if(res.code==200){
          if(res.data.siteContentInfoResult.linkUrl==null||res.data.siteContentInfoResult.linkUrl==""||res.data.siteContentInfoResult.linkUrl==" "){
            this.$router.push({path:'/expert_details',query:{num: num,contentId: contentId,channelId:channelId}});
            }else{
            window.open(res.data.siteContentInfoResult.linkUrl);
          }
          console.log(res.data)
          that.$loading.hideLoading();
        }else{
          that.$alert('没有附件', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      });
      }
    },
      index(){

        this.titlename = this.$route.query.titlename;
        this.channelid = this.$route.query.channelid;
        if(this.titlename=='本周关注'){
            this.GetHomePageBlockInfo(2374,1);
        }else if(this.titlename=='编辑推荐'){
              this.GetHomePageBlockInfo(1867,1);
        }else if(this.titlename=='期刊纵览'){
          this.GetHomePageBlockInfo(1407,1);
        }else if(this.titlename=='指南共识'){
              this.GetHomePageBlockInfo(1868,1);
        }else if(this.titlename=='观点纵横'){
              this.GetHomePageBlockInfo(1869,1);
        }else if(this.titlename=='技术产品'){
              this.GetHomePageBlockInfo(1870,1);
        }else if(this.titlename=='会议热点'){
              this.GetHomePageBlockInfo(1404,1);
        }else if(this.titlename=='会议消息'){
              this.GetHomePageBlockInfo(1384,1);
        }else if(this.titlename=='学术会议'){
              this.GetHomePageBlockInfo(2317,1);
        }else if(this.titlename=='专家指导'){
              this.GetHomePageBlockInfo(2318,1);
        }else if(this.titlename=='病例分享'){
              this.GetHomePageBlockInfo(1872,1);
        }else if(this.titlename=='视频课件'){
              this.GetHomePageBlockInfo(2320,1);
        }else if(this.titlename=='2020年中国心脏大会\n          '){
              this.GetHomePageBlockInfo(2925,1);
        }else if(this.titlename.indexOf('2021年中国心脏大会')>-1){
              this.GetHomePageBlockInfo(3386,1);
        }else if(this.titlename.indexOf('2022年中国心脏大会')>-1){
              this.GetHomePageBlockInfo(3742,1);
        }
        else if(this.titlename.indexOf('2019年中国心脏大会')>-1){
              this.GetHomePageBlockInfo(2578,1);
        }else if(this.titlename=='2017年中国心脏大会'){
              this.GetHomePageBlockInfo(2401,1);
        }else if(this.titlename=='2018年中国心脏大会'){
              this.GetHomePageBlockInfo(2399,1);
        }else if(this.titlename=='\n    2016年中国心脏大会\n'){
              this.GetHomePageBlockInfo(1677,1);
        }else if(this.titlename=='第十届海峡两岸医药卫生交流协会心血\n          '){
              this.GetHomePageBlockInfo(2579,1);
        }else if(this.titlename=='第八届海峡两岸医药卫生交流协会心血管专业委员会年会'){
              this.GetHomePageBlockInfo(2402,1);
        }else if(this.titlename=='第九届海峡两岸医药卫生交流协会心血管专业委员会年会'){
              this.GetHomePageBlockInfo(2400,1);
        }else if(this.titlename=='第19届中国南方国际心血管病学术会议'){
              this.GetHomePageBlockInfo(1798,1);
        }else if(this.titlename=='\n    第七届海峡两岸医药卫生交流协会心血管专业委员会年会\n'){
              this.GetHomePageBlockInfo(1678,1);
        }else if(this.titlename=='精品会议'){
              this.GetHomePageBlockInfo(1398,1);
        }else if(this.titlename=='2021年中国心脏大会'){
              this.GetHomePageBlockInfo(3386,1);
        }else if(this.titlename == '通知公示'){
          this.GetHomePageBlockInfo(3876,1);
        }


        this.total = this.list.length;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },

      handleCurrentChange(val) {
        this.curr = val;
     if(this.titlename=='本周关注'){
            this.GetHomePageBlockInfo(2374,1);
        }else if(this.titlename=='编辑推荐'){
              this.GetHomePageBlockInfo(1867,1);
        }else if(this.titlename=='期刊纵览'){
          this.GetHomePageBlockInfo(1407,1);
        }else if(this.titlename=='指南共识'){
              this.GetHomePageBlockInfo(1868,1);
        }else if(this.titlename=='观点纵横'){
              this.GetHomePageBlockInfo(1869,1);
        }else if(this.titlename=='技术产品'){
              this.GetHomePageBlockInfo(1870,1);
        }else if(this.titlename=='会议热点'){
              this.GetHomePageBlockInfo(1404,1);
        }else if(this.titlename=='会议消息'){
              this.GetHomePageBlockInfo(1384,1);
        }else if(this.titlename=='学术会议'){
              this.GetHomePageBlockInfo(2317,1);
        }else if(this.titlename=='专家指导'){
              this.GetHomePageBlockInfo(2318,1);
        }else if(this.titlename=='病例分享'){
              this.GetHomePageBlockInfo(1872,1);
        }else if(this.titlename=='视频课件'){
              this.GetHomePageBlockInfo(2320,1);
        }else if(this.titlename=='2020年中国心脏大会\n          '){
              this.GetHomePageBlockInfo(2925,1);
        }else if(this.titlename=='2019年中国心脏大会\n          '){
              this.GetHomePageBlockInfo(2578,1);
        }else if(this.titlename=='2017年中国心脏大会'){
              this.GetHomePageBlockInfo(2401,1);
        }else if(this.titlename=='2018年中国心脏大会'){
              this.GetHomePageBlockInfo(2399,1);
        }else if(this.titlename=='\n    2016年中国心脏大会\n'){
              this.GetHomePageBlockInfo(1677,1);
        }else if(this.titlename=='第十届海峡两岸医药卫生交流协会心血\n          '){
              this.GetHomePageBlockInfo(2579,1);
        }else if(this.titlename=='第八届海峡两岸医药卫生交流协会心血管专业委员会年会'){
              this.GetHomePageBlockInfo(2402,1);
        }else if(this.titlename=='第九届海峡两岸医药卫生交流协会心血管专业委员会年会'){
              this.GetHomePageBlockInfo(2400,1);
        }else if(this.titlename=='第19届中国南方国际心血管病学术会议'){
              this.GetHomePageBlockInfo(1798,1);
        }else if(this.titlename=='\n    第七届海峡两岸医药卫生交流协会心血管专业委员会年会\n'){
              this.GetHomePageBlockInfo(1678,1);
        }else if(this.titlename=='精品会议'){
              this.GetHomePageBlockInfo(1398,1);
        }else if(this.titlename=='2021年中国心脏大会'){
              this.GetHomePageBlockInfo(3386,1);
        }
        console.log(`当前页: ${val}`);
      },

      //下载排行鼠标悬停
      addtop3(num,id){
        if(num==1){
          for(var i=0;i<this.xia.length;i++){
            if(id==i){
              this.xia[i].zt = true;
              this.xia.push('1');
              this.xia.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.xia.length;i++){
            this.xia[i].zt = false;
            this.xia.push('1');
            this.xia.pop('1');
          }
        }
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list2.length;i++){
            if(id==this.list2[i].id){
              this.list2[i].zt = true;
              this.list2.push('1');
              this.list2.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list2.length;i++){
            this.list2[i].zt = false;
            this.list2.push('1');
            this.list2.pop('1');
          }
        }
      },
  },
  created(){
    this.$loading.showLoading();
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    padding-bottom: 42px;
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .express_nav2 {
        width: 100%;
        margin-bottom: 48px;
        .express_rtitle {
          width: 100%;
          overflow: hidden;
          border-bottom: 3px solid #DBDBDB;
          padding-bottom: 11px;
          position: relative;
          .waike {
            width: 50%;
            float: left;
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #000000;
            line-height: 23px;
          }


          .waixian {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 81px;
            height: 3px;
            background: var(--biao);
          }
        }
        .express_nav2r {
          width: 100%;
          overflow: hidden;
          margin-top: 29px;
          .express_list2 {
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            margin-bottom: 28px;
            .express_dian {
              width: 10px;
              height: 10px;
              background: #DBDBDB;
              border-radius: 50%;
              margin-right: 15px;
              float: left;
              margin-top: 6px;
            }

            .express_wen {
              width: 91%;
              float: left;

              .wen1 {
                width: 100%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                margin-bottom: 12.2px;

                .span3 {
                  width: 70%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  float: left;
                }
              }

              .wen2 {
                width: 100%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                margin-bottom: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }

            .zhai {
              width: 90%;
              padding-left: 31px;
              overflow: hidden;
              float: left;

              .wen3 {
                width: 50%;
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #636363;
                float: left;
              }

              .zhai_left,
              .zhai_right {
                font-size: 14px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                float: right;
              }

              .zhai_right {
                margin-left: 30px;
              }

              .zhai_left:hover {
                text-decoration: underline;
                color: var(--biao);
              }

              .zhai_right:hover {
                text-decoration: underline;
                color: var(--biao);
              }
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}

.add3 {
  background-color: #FAFAFA !important;
}
</style>



// WEBPACK FOOTER //
// src/components/secondary/download_details.vue